/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a product group.
 */
import { mapGetters } from 'vuex';
import productTagService from './../../../../services/productTag';
import productTagTransformer from './../../../../transformers/productTag';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';

export default {
  data() {
    return {
      form: new Forms({
        tag: {
          value: '',
          type: 'text',
        },
       
      }),
      loading: false,
    };
  },

  created() {
    this.show();
  },

  computed: {
    
  },

  methods: {
    /**
     * Method to update the product group.
     */
    update() {
      this.form.loading = true;
      const productTag = productTagTransformer.send(this.form.data());
      productTagService.update(store.state.route.params.id, productTag)
      .then(() => {
        this.form.loading = false;
        this.$message({
          message: this.$t('static.productTags.edit.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'productTags.index',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetches the product group object for editing.
     */
    show() {
      this.loading = true;
      productTagService.show(store.state.route.params.id).then((productTag) => {
        this.form.assignData(productTag);
        this.loading = false;
      });
    },
  },

  watch: {
   
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productTag/edit/edit.js